(() => {
  if (customElements.get('basic-preset-builder')) return;

  class BasicPresetBuilder extends HTMLElement {
    connectedCallback() {
      this.variants = JSON.parse(this.querySelector('[data-preset-variants]').textContent);
      const selected = this.variants.find((variant) => variant.available) || this.variants[0];
      this.selection = [...selected.options];
      this.setButtons = [...this.querySelectorAll('.ba-preset__set')];
      this.sizeButtons = [...this.querySelectorAll('.ba-preset__size')];
      this.addButton = this.querySelector('[data-add]');
      this.error = this.querySelector('[data-error]');

      this.setButtons.forEach((button) => button.addEventListener('click', () => this.choose(0, button.dataset.optionValue)));
      this.sizeButtons.forEach((button) => button.addEventListener('click', () => this.choose(1, button.dataset.optionValue)));
      this.addButton.addEventListener('click', () => this.addToCart());
      this.render();
    }

    choose(index, value) {
      this.selection[index] = value;
      this.hideError();
      this.render();
      if (index === 0) this.previewSelectedSet();
    }

    currentVariant() {
      return this.variants.find((variant) => variant.options.every((value, index) => value === this.selection[index]));
    }

    render() {
      const variant = this.currentVariant();
      this.setButtons.forEach((button) => {
        const selected = button.dataset.optionValue === this.selection[0];
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-checked', String(selected));
      });
      this.sizeButtons.forEach((button) => {
        const value = button.dataset.optionValue;
        const selected = value === this.selection[1];
        const available = this.variants.some((item) => item.options[0] === this.selection[0] && item.options[1] === value && item.available);
        button.classList.toggle('is-selected', selected);
        button.classList.toggle('is-unavailable', !available);
        button.setAttribute('aria-checked', String(selected));
        button.setAttribute('aria-disabled', String(!available));
      });
      this.querySelector('[data-current-set]').textContent = this.selection[0];
      this.querySelector('[data-current-size]').textContent = this.selection[1];
      this.querySelector('[data-selection-summary]').textContent = `7 helai · ${this.selection[0]} · ${this.selection[1]}`;
      this.addButton.disabled = !variant?.available;
      this.addButton.textContent = variant?.available ? 'Tambah ke troli — RM100' : 'Pilihan ini kehabisan stok';
      if (variant && !variant.available) this.showError(`${this.selection[0]} · ${this.selection[1]} kehabisan stok. Sila pilih saiz lain.`);
    }

    previewSelectedSet() {
      const variant = this.variants.find((item) => item.options[0] === this.selection[0] && (item.featured_media || item.featured_image));
      const mediaId = variant?.featured_media?.id;
      const gallery = document.querySelector('media-gallery');
      const media = mediaId ? gallery?.querySelector(`[data-media-id$="-${mediaId}"]`) : null;
      if (media?.dataset.mediaId && gallery?.setActiveMedia) gallery.setActiveMedia(media.dataset.mediaId, true);
    }

    async addToCart() {
      const variant = this.currentVariant();
      if (!variant?.available) {
        this.showError(`${this.selection[0]} · ${this.selection[1]} kehabisan stok. Sila pilih pilihan lain.`);
        return;
      }
      this.addButton.disabled = true;
      this.addButton.textContent = 'Menambah ke troli…';
      try {
        const response = await fetch(this.dataset.cartAddUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] }),
        });
        if (!response.ok) throw new Error((await response.json()).description || 'Tidak dapat menambah ke troli.');
        this.addButton.textContent = 'Sudah ditambah ✓';
        window.setTimeout(() => window.location.assign(this.dataset.cartUrl), 350);
      } catch (error) {
        this.showError(error.message || 'Tidak dapat menambah ke troli. Sila cuba lagi.');
        this.addButton.disabled = false;
        this.render();
      }
    }

    showError(message) { this.error.textContent = message; this.error.hidden = false; }
    hideError() { this.error.hidden = true; this.error.textContent = ''; }
  }

  customElements.define('basic-preset-builder', BasicPresetBuilder);
})();
